// jQuery
global.jQuery = require('jquery');
global.$ = global.jQuery;

jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};


$(function () {

    let app = require('./modules/core')();
    app.initBootstrap();
    app.initLazyLoad();
    app.initLightbox();
    app.initSlickCarousel();
    app.scrollToAnchor();
    app.scrollToAccordionItem();
    app.detectUrlScrollHash();
    app.convertCryptedEmails();
    app.initMobileMenu();
    app.initRrssb();
    app.keepTokenAlive();
    //app.navDropdownHover(); // Hover instead of click on Nav dropdowns
    //app.initDatePicker();
    app.initWowJs();
    app.initStickyEl();
    //app.initTooltips();
    app.announcementBarDismiss();
    app.initBootstrapToggle();



    let googleMaps = require('./modules/google-maps')();
    googleMaps.assign();


    $(".megamenu").on("click", function(e) {
        e.stopPropagation();
    });

});
